import styled from 'styled-components'
import { colors } from 'client/styles'

export const SelectBox = styled.div`
  position: relative;
  border-radius: 5px;

  svg {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-end: 15px;
    transform: translateY(-50%);
    pointer-events: none;
    fill: ${colors.grey2};
  }
`

export const Select = styled.button`
  appearance: none;
  border: 1px solid ${colors.grey4};
  border-radius: 5px;
  padding-block: 1rem;
  padding-inline: 1rem;
  font-size: 1rem;
  background-color: ${colors.white};
  width: 100%;
  height: 100%;
  text-align: start;

  &:focus {
    border-color: ${colors.grey1};
    outline: none;
  }
`

export const AgesList = styled.ul`
  position: absolute;
  inset-block-start: calc(100% + 5px);
  background-color: ${colors.white};
  width: 100%;
  border: 1px solid ${colors.grey4};
  border-radius: 8px;
  padding-block: 5px;
  padding-inline: 0;
  z-index: var(--z-low);

  li {
    padding-block: 5px;
    padding-inline: 10px;
    line-height: 1.3;
    cursor: pointer;

    &:hover {
      background-color: ${colors.yellow2};
    }

    &:focus {
      background-color: ${colors.yellow2};
      outline: none;
    }
  }
`

export const AgeSelectorBase = styled.div`
  flex: 1 0 33.33%;
  max-width: calc(33.33% - 1rem);
  margin-block-start: 21px;

  &:not(:nth-of-type(3n + 1)) {
    margin-inline-start: 21px;
  }

  &:nth-of-type(1),
  &:nth-of-type(2),
  &:nth-of-type(3) {
    margin-block-start: 0;
  }

  ${({ isInvalid }) =>
    isInvalid &&
    `
    ${SelectBox} {
      box-shadow: 0px 0px 0px 1px ${colors.red};
    }

    ${Select} {
      border-color: ${colors.red};
    }
  `}
`
